import { Language, Theme } from '../constants/enums'

const LANGUAGE_STORAGE_KEY = 'userLanguage'
const THEME_STORAGE_KEY = 'userTheme'

/**
 * Загрузить язык пользователя из localStorage
 * Возвращает null если кеш пуст или невалиден
 */
export const loadLanguageFromCache = (): Language | null => {
  const cachedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (!cachedLanguage) return null

  try {
    const languageId = Number.parseInt(cachedLanguage, 10)
    
    // Проверяем что значение является валидным Language enum
    if (Number.isNaN(languageId) || !Object.values(Language).includes(languageId)) {
      console.warn('[PreferencesCache] Invalid language in cache. Clearing.')
      clearLanguageCache()
      return null
    }
    
    return languageId as Language
  } catch (error) {
    console.warn('[PreferencesCache] Failed to parse language cache. Clearing.', error)
    clearLanguageCache()
    return null
  }
}

/**
 * Сохранить язык пользователя в localStorage
 */
export const saveLanguageToCache = (language: Language): void => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language.toString())
}

/**
 * Очистить язык пользователя из localStorage
 */
export const clearLanguageCache = (): void => {
  localStorage.removeItem(LANGUAGE_STORAGE_KEY)
}

/**
 * Загрузить тему пользователя из localStorage
 * Возвращает null если кеш пуст или невалиден
 */
export const loadThemeFromCache = (): Theme | null => {
  const cachedTheme = localStorage.getItem(THEME_STORAGE_KEY)
  if (!cachedTheme) return null

  try {
    const themeId = Number.parseInt(cachedTheme, 10)
    
    // Проверяем что значение является валидным Theme enum
    if (Number.isNaN(themeId) || !Object.values(Theme).includes(themeId)) {
      console.warn('[PreferencesCache] Invalid theme in cache. Clearing.')
      clearThemeCache()
      return null
    }
    
    return themeId as Theme
  } catch (error) {
    console.warn('[PreferencesCache] Failed to parse theme cache. Clearing.', error)
    clearThemeCache()
    return null
  }
}

/**
 * Сохранить тему пользователя в localStorage
 */
export const saveThemeToCache = (theme: Theme): void => {
  localStorage.setItem(THEME_STORAGE_KEY, theme.toString())
}

/**
 * Очистить тему пользователя из localStorage
 */
export const clearThemeCache = (): void => {
  localStorage.removeItem(THEME_STORAGE_KEY)
}

/**
 * Очистить все настройки пользователя из localStorage
 */
export const clearAllPreferencesCache = (): void => {
  clearLanguageCache()
  clearThemeCache()
}
